import styled from "styled-components";
export const Box = styled.div`
  position: relative;
  height: 100vh;

  .notfound {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-width: 767px;
    width: 100%;
    line-height: 1.4;
    padding: 0 15px;
    .notfound-404 {
      position: relative;
      height: 150px;
      line-height: 150px;
      margin-bottom: 25px;
      h1 {
        font-family: Number;
        font-size: 175px;
        font-weight: 900;
        margin: 0;
        background: url("./images/text.png");
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: cover;
        background-position: center;
      }
    }
    h2 {
      font-family: IRANSans;
      font-size: 26px;
      font-weight: 700;
      margin: 0;
    }

    p {
      font-family: IRANSans;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0px;
      text-transform: uppercase;
    }

    a {
      font-family: IRANSans;
      display: inline-block;
      text-transform: uppercase;
      color: #fff;
      text-decoration: none;
      border: none;
      background: #5c91fe;
      padding: 10px 40px;
      font-size: 14px;
      font-weight: 700;
      border-radius: 1px;
      margin-top: 15px;
      -webkit-transition: 0.2s all;
      transition: 0.2s all;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .notfound-404 {
      height: 110px;
      line-height: 110px;
      h1 {
        font-size: 120px;
      }
    }
  }
`;
